import React, { Suspense, useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PatentDetails from "./components/PatentsDetails";
import PatentContextProvider from "./context/PatentContextProvider";
import Claims from "./components/Claims";
import Company from "./components/About/Company";
import Alert from "./components/About/Alert";
import Contact from "./components/Contact";
import History from "./components/History";
import PressReleases from "./components/PressReleases";
import PageList from "./customcms/src/components/admin/PageList";
import CreatePage from "./customcms/src/components/admin/CreatePage";
import EditPage from "./customcms/src/components/admin/EditPage";
import AdminLogin from "./customcms/src/components/admin/Login";
import Blogs from "./customcms/src/components/admin/Blogs";
import DetailPage from "./customcms/src/components/admin/DetailPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminAlert from "./customcms/src/components/admin/AdminAlert";
import RegisteredContacts from "./customcms/src/components/admin/RegisteredContacts";
import WorkingModel from "./components/Operations/WorkingModel";
import BestPractices from "./components/Operations/BestPractices";
import ChatBotInformation from "./customcms/src/components/admin/ChatBotInformation";
import Glossary from "./components/Operations/Glossary";
import Compliance from "./components/Operations/Compliance";
import { TestUseCases } from "./components/TestUseCases";
import ScrollToTop from "./components/ScrollToTop";
import Features from "./components/Operations/Feartures";
import AccessU2 from "./components/AccessU2";
import Infringement from "./customcms/src/components/admin/Infringements";
import PortobelloMarketplace from "./components/Portobello";
import PatentInfo from "./components/PatentInfo";
import { Trade } from "./components/Trade";
import UnderConstruction from "./components/UnderConstruction";
import AskJeevesAi from "./components/AskJeevesAi";
import PropertiesByPhone from "./components/PropertiesByPhone";
import { PatentedTechnology } from "./components/PatentedTechnology";
import { TermOfUse } from "./components/TermOfUse";
import { LicenseAggrement } from "./components/LicenseAggrement";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import UseCases from "./components/Operations/UseCases";
import { LeaderShip } from "./components/Leadership";
import Register from "./components/Register";
import { Conclusion } from "./components/Conclusion";
import { PatentLicensing } from "./components/PatentLicensing";
import { PatentLicensingModal } from "./components/Modal/PatentLicensingModal";
import { EthicalDeployment } from "./components/EthicalDeployment";
import { DynamicUserPatent } from "./components/DynamicUserPatents";
import RequestedInfringement from "./customcms/src/components/admin/RequestedInfringements";
import Companies from "./customcms/src/components/admin/Companies";
import WebsiteTracking from "./customcms/src/components/admin/WebsiteTracking";
import Attorneys from "./customcms/src/components/admin/Attorneys";
import { AddCompanyForm } from "./customcms/src/components/admin/AddCompanyForm";
import { AddAttorneyForm } from "./customcms/src/components/admin/AddAttorneyForm";
import { EditCompanyData } from "./customcms/src/components/admin/EditCompanyData";
import { EditAttorneyForm } from "./customcms/src/components/admin/EditAttorneyData";
import { EditLitigatorData } from "./customcms/src/components/admin/EditLitigatorData";
import PublicChatView from "./customcms/src/components/PublicChatView";
// import { SampleInfringementReport } from "./components/SampleInfringementReport";
import { SampleInfringementReport } from "./components/SampleInfringementReport";
import { AddLitigatorsForm } from "./customcms/src/components/admin/AddLitigators";
import Litigators from "./customcms/src/components/admin/Litigators";
import Signup from "./customcms/src/components/admin/Signup";
import { PatentInfringement } from "./components/PatentInfringement";
import AskJeevesHome from "./customcms/src/components/admin/AskJeevesChat";
import ChatLayout  from "./customcms/src/components/admin/ChatLayout";  
import AppProvider from "./context/AppContext";
import ExpiredLink from "./customcms/src/components/ExpiredLink";
const PatentIntro = React.lazy(() => import("./components/PatentIntro"));
// import { AddLitigatorsForm } from "./customcms/src/components/admin/AddLitigators";
function App() {

  return (
    <div className="App overflow-hidden">
      <PatentContextProvider>
        <AppProvider>
        <PatentLicensingModal />
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/"
              element={
                <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><PatentIntro /></Suspense>
              }
            />
            <Route path="/conclusion"
              element={
                <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><Conclusion /></Suspense>
              } />
            <Route path="/portobello-marketplace" element={
              <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><PortobelloMarketplace /></Suspense>
            } />
            <Route path="/properties-by-phone"
              element={
                <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><PropertiesByPhone /></Suspense>
              } />
            <Route path="/register/:id"
              element={
                <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><Register /></Suspense>
              } />
            <Route path="/infringement-reports"
              element={
                <Suspense fallback={<div className="h-screen bg-white"></div>}>
                  <SampleInfringementReport />
                </Suspense>
              } />
            <Route path="/AskJeevesAi" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><AskJeevesAi /></Suspense>} />
            <Route path="/AccessU2" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><AccessU2 /></Suspense>} />
            <Route path="/chatbot-information" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><ChatBotInformation /></Suspense>} />
            <Route path="/patent-infringement" element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><PatentInfringement /></Suspense>} />
            {/* <Route path="/not-found"
              element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><UnderConstruction /></Suspense>} /> */}
            <Route
              path="/patent-details/:patentId"
              element={<PatentDetails />}
            />
              <Route path="/ethical-deployment" element={<EthicalDeployment />} />
              <Route path="/not-found" element={<ExpiredLink /> } />
            <Route path="/patented" element={<PatentedTechnology />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/terms-of-use" element={<TermOfUse />} />
            <Route path="/leadership" element={<LeaderShip />} />
            <Route path="/end-user-license-agreement" element={<LicenseAggrement />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/claims" element={<Claims />} />
            <Route path="/useCases" element={<UseCases />} />
            <Route path="/patent-info/:patentId" element={<PatentInfo />} />
            <Route path="/about-us" element={<Company />} />
            <Route path="/history" element={<History />} />
            <Route path="/alert-system" element={<Alert />} />
            {/* <Route path="/chats" element={<AskJeevesHome />} /> */}
            <Route path="/chats" element={<ChatLayout />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/press-releases" element={<PressReleases />} />
            <Route path="/working-model" element={<WorkingModel />} />
            <Route path="/best-practices" element={<BestPractices />} />
            <Route path="/use-cases" element={<TestUseCases />} />
            <Route path="/glossary" element={<Glossary />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/register" element={<Signup />} />
            {/* Protected Routes */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/patent-licensing"
                element={
                  <Suspense fallback={<div className="h-screen bg-white">Loading...</div>}><PatentLicensing /></Suspense>
                } />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/allpages" element={<PageList />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/editAttorney/:id" element={<EditAttorneyForm />} />
              <Route path="/editlitigator/:id" element={<EditLitigatorData />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/editCompany/:id" element={<EditCompanyData />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/add-company" element={<AddCompanyForm />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/add-litigator" element={<AddLitigatorsForm />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/add-attorney" element={<AddAttorneyForm />} />
            </Route>
            {/* <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/add-litigators" element={<AddLitigatorsForm />} />
            </Route> */}
            {/* <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/companies" element={<Companies />} />
            </Route> */}
            {/* <Route element={<ProtectedRoute allowedRoles={["user", "admin"]} />}>
              <Route path="/attorneys" element={<Attorneys />} />
            </Route> */}
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/pages-create" element={<CreatePage />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/pages/edit/:id" element={<EditPage />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/alerts" element={<AdminAlert />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/tracking" element={<WebsiteTracking />} />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route
                path="/contact-requests"
                element={<RegisteredContacts />}
              />
            </Route>
            <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/infringments" element={<Infringement />} />
              <Route path="/requested-infringements" element={<RequestedInfringement />} />
            </Route>
            {/* <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
              <Route path="/litigators" element={<Litigators />} />
            </Route> */}
              <Route path="/login" element={<AdminLogin />} />
              <Route path = "/share" element={<PublicChatView />} />
            <Route path="/page/:slug" element={<DetailPage />} />
            <Route path="/:name" element={<DynamicUserPatent />} />
            <Route path="/our-blogs" element={<Blogs />} />
            <Route path="*" element={<PatentIntro />} />
            <Route path="/features" element={<Features />} />
          </Routes>
          </Router>
          </AppProvider>
      </PatentContextProvider>
    </div>
  );
}

export default App;
